var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#031434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5674 15H9.43262V7.50781H10.5674V15ZM9.33691 5.47754C9.33691 5.21777 9.40072 5.02865 9.52832 4.91016C9.65592 4.78711 9.81543 4.72559 10.0068 4.72559C10.1891 4.72559 10.3464 4.78711 10.4785 4.91016C10.6107 5.0332 10.6768 5.22233 10.6768 5.47754C10.6768 5.73275 10.6107 5.92415 10.4785 6.05176C10.3464 6.1748 10.1891 6.23633 10.0068 6.23633C9.81543 6.23633 9.65592 6.1748 9.52832 6.05176C9.40072 5.92415 9.33691 5.73275 9.33691 5.47754Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.dd476b66d65ca16eb1afbc43b7a97735.svg";
export { ForwardRef as ReactComponent };